<script>
import HotAreas from './HotAreas.vue';

export default {
  props: ['instance', 'meta', 'global', 'componentKey', 'emit', 'on'],
  components: {
    HotAreas,
  },
  render: function (createElement) {
    const {
      key,
      children,
      component: { component: Component },
      data,
      style,
      commonStyle,
      position,
    } = this.instance;
    const hotAreas = this.instance.component.__implementHotArea
      ? createElement(HotAreas, {
          props: {
            global: this.global,
            meta: this.meta,
            instance: this.instance,
          },
        })
      : null;

    return createElement(
      Component,
      {
        key,
        props: {
          data,
          componentKey: this.componentKey,
          commonStyle,
          styleForm: style,
          hotAreas,
          global: this.global,
          meta: this.meta,
          emit: this.emit,
          on: this.on,
        },
      },
      this.$slots.default,
    );
  },
};
</script>
